<template v-if="portalId">
  <portal :to="portalId">
    <slot />
  </portal>
</template>

<script>
export default {
  name: 'SModalPortalTo',

  props: {
    isModalHeaderTitle: {
      type: Boolean,
      default: false,
    },

    isModalHeaderSubTitle: {
      type: Boolean,
      default: false,
    },

    isConfirmModalDescription: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    portalId() {
      // try to find the component with data "portalId" to determine the correct "portal :to"
      // each portal must have a unique name

      const portalIdAttr = this.getPortalIdAttr()

      // abort if it takes more than 10 levels up the DOM
      const max = 10
      let currParent = null
      for (let i = 0; i < max; i++) {
        currParent = currParent ? currParent.$parent : this.$parent
        if (currParent?.[portalIdAttr]) {
          break
        }
      }
      return currParent?.[portalIdAttr]
    },
  },

  methods: {
    getPortalIdAttr() {
      if (this.isModalHeaderTitle) return 'headerTitlePortalId'
      if (this.isModalHeaderSubTitle) return 'headerSubTitlePortalId'
      if (this.isConfirmModalDescription) return 'descriptionPortalId'
      return 'footerPortalId'
    },
  },
}
</script>
